import { Component, DoCheck, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit, DoCheck {
  compSlug: string;
  scheduleSlug: string;
  modules: any = [];
  upcoming_deadlines = [];
  previous_deadlines = [];
  isLoading = false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public metaService: MetaService,
    private detailService: CompDetailService,
    public imageOptimizer: ImageOptimizerService
  ) {
  }

  ngOnInit(): void {
    this.scheduleSlug = this.route.snapshot.params.schedule_slug;
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.getScheduleModule();
  }

  ngDoCheck(): void {
    this.scheduleSlug = this.route.snapshot.params.schedule_slug;
    if (this.scheduleSlug !== this.route.snapshot.params.schedule_slug) {
      this.getScheduleModule();
    }
  }

  getScheduleModule(): void {
    this.isLoading = true;
    this.detailService.scheduleModule(this.compSlug, this.scheduleSlug).subscribe(
      (response: any) => {
        this.modules = response[0];
        this.isLoading = false;
        const today = new Date();
        const todayDate = new Date(today.getTime() - (today.getTimezoneOffset() * 60000))
          .toISOString()
          .split('T')[0];

        if (this.modules?.deadlines?.length > 0) {
          this.modules.deadlines?.map((item) => {
            if (item.date >= todayDate) {
              this.upcoming_deadlines.push(item);
            } else {
              this.previous_deadlines.push(item);
            }
          });
        }
        this.updateMetaInfo();

      }, (error) => {
        console.log(error);
        this.isLoading = false;
      });
  }

  updateMetaInfo(): void {
    this.detailService.fetchCompetition(this.compSlug, (competition) => {
      let metaInfo: MetaDefinition[] = [];
      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location?.country?.name} | ${this.scheduleSlug.charAt(0).toUpperCase()
        + this.scheduleSlug.slice(1)}`;
      const description = `${this.upcoming_deadlines.map(deadline =>
        (' ' + deadline.type + ' - ' + new Date(deadline.date).toISOString().split('T')[0]) + ' ')}`;
      const image = competition.image ?  this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }

}
